import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "config/api.config";

export const generalApi = createApi({
  reducerPath: "general",
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    trackLogin: builder.mutation<void, void>({
      query: () => ({
        method: "POST",
        url: "History/TrackLogin",
      }),
    }),
  }),
});

export const { useTrackLoginMutation } = generalApi;
